// @flow
import * as React from 'react';
import styled from 'styled-components';

const TutorialOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.65s;
  width: 100%;
  height: 100%;
  opacity: 0;
`;

const Content = styled.div`
  background-image: ${({ image }) => (`url(${image})`)};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  width: 300px;
  height: 180px;
  margin: 8px;
  position: relative;

  &:hover {
    cursor: pointer;
  }

  &:hover ${TutorialOverlay} {
    opacity: 1
  }
`;

const OverlayTitleContent = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.75);
  width: 100%;
  padding: 8px;
  text-align: center;
`;

const OverlayTitle = styled.div`
  font-size: 24px;
  color: white;
  display: block;
  line-height: 36px;
`;

type Props = {
  onClick: Function,
  image: string,
  title: string,
};

export default function TutorialCard(props: Props) {
  return (
    <Content onClick={props.onClick} image={props.image}>
      <OverlayTitleContent>
        <OverlayTitle>{props.title}</OverlayTitle>
      </OverlayTitleContent>
      <TutorialOverlay />
    </Content>
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/tutorials/components/TutorialCard.js